// export * from './src/angularselfbits'

export { SelfbitsAngular, SelfbitsAngularModule, SELFBITS_PROVIDERS } from './src/angularselfbits'
export { SelfbitsAppConfig, SelfbitsAuthConfig, SelfbitsHttp } from './src/utils/interfaces'
export { SELFBITS_CONFIG } from './src/utils/tokens'
